import React, { useState } from "react";
import Images from "../data/Images";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import { services } from "../data/servicesdata";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  return (
    <div className="w-full">
      <div className="bg-red-800 text-white text-md px-4 py-2 flex flex-wrap items-center justify-between gap-2 sm:gap-4">
        {/* Contact Info */}
        <span className="w-full sm:w-auto text-center sm:text-left">
          Contact: info@newwaysecurity.com
        </span>

        {/* Request a Quote Button */}
        <a
          href="/contact"
          className="text-white hover:text-red-300 w-full sm:w-auto text-center sm:text-left sm:ml-auto"
        >
          Request a Quote
        </a>

        {/* Social Icons */}
        <div className="flex items-center justify-center gap-3 w-full sm:w-auto">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-300"
          >
            <FaFacebookF size={18} />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-300"
          >
            <FaTwitter size={18} />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-300"
          >
            <FaLinkedinIn size={18} />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-300"
          >
            <FaYoutube size={18} />
          </a>
        </div>
      </div>

      <div className="bg-white shadow-md border border-red-800 rounded-3xl px-6 py-2 mx-auto my-4 w-[90%]">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="hidden custom:flex md:w-[400px] gap-2 justify-start">
            <a
              href="/nws/gaurd/login.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Security Guard Login
            </a>
            <a
              href="/nws/customer/login.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Client Login
            </a>
          </div>

          <div className="hidden custom:flex justify-center w-full md:w-auto">
            <a href="/">
              <img src={Images.logopng} alt="Logo" className="h-24" />
            </a>
          </div>

          <div className="hidden custom:flex md:w-[400px] gap-2 justify-end">
            <a
              href="/nws/customer/register.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Client Registration
            </a>
            <a
              href="/nws/gaurd/register.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Security Guard Registration
            </a>
          </div>

          <div className="custom:hidden flex w-full justify-between items-center">
            <img src={Images.logopng} alt="Logo" className="h-12" />
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-red-800"
            >
              {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="bg-red-800 text-white px-4 py-4 space-y-3 custom:hidden text-md">
          <div className="flex flex-col gap-2">
            <a
              href="/nws/gaurd/login.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Security Guard Login
            </a>
            <a
              href="/nws/customer/login.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Client Login
            </a>
            <a
              href="/nws/customer/register.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Client Registration
            </a>
            <a
              href="/nws/gaurd/register.php"
              className="bg-red-800 text-white px-3 py-2 rounded hover:bg-red-700 text-center"
            >
              Security Guard Registration
            </a>
          </div>

          <hr className="border-white my-2" />

          <nav className="flex flex-col text-xl gap-2">
            <a
              href="/"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Home
            </a>
            <a
              href="/about"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              About
            </a>

            <div className="flex flex-col">
              <button
                onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
                className="text-left w-full text-md relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
              >
                Services {servicesDropdownOpen ? "▲" : "▼"}
              </button>
              {servicesDropdownOpen && (
                <div className="pl-4 space-y-1 text-md">
                  {services.map((service) => (
                    <a
                      key={service.id}
                      href={`/services/${service.id}`}
                      className="block px-4 py-2 hover:bg-red-100"
                    >
                      {service.title}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="/technology"
              className="relative text-md text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Technology
            </a>
            <a
              href="/location"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Location
            </a>
            <a
              href="/career"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Career
            </a>
            <a
              href="/emergencies"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Emergencies
            </a>
            <a
              href="/contact"
              className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
            >
              Contact
            </a>
          </nav>
        </div>
      )}

      <nav className="bg-red-800 px-4 py-3 hidden custom:flex justify-center gap-6 text-white font-medium text-xl">
        <a
          href="/"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Home
        </a>
        <a
          href="/about"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          About
        </a>

        <div className="relative group">
          <a
            href="/services"
            className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
          >
            Services
          </a>

          <div className="absolute left-0 mt-2 w-64 bg-white text-red-800 rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all z-50">
            {[
              {
                name: "Uniformed Security",
                link: "/services/uniformed-security",
              },
              { name: "Mobile Security", link: "/services/mobile-security" },
              {
                name: "Fire Watch Security",
                link: "/services/fire-watch-security",
              },
              {
                name: "Concierge Security",
                link: "/services/concierge-security",
              },
              {
                name: "Elite Suite & Tie Security",
                link: "/services/elite-suite-tie-security",
              },
              {
                name: "Executive Protection",
                link: "/services/executive-protection",
              },
              { name: "Event Security", link: "/services/event-security" },
              {
                name: "Condominium Security",
                link: "/services/condominium-security",
              },
              {
                name: "Residential Security",
                link: "/services/residential-security",
              },
              {
                name: "Commercial Security",
                link: "/services/commercial-security",
              },
              {
                name: "Construction Security",
                link: "/services/construction-security",
              },
              {
                name: "Industrial Security",
                link: "/services/industrial-security",
              },
              { name: "Retail Security", link: "/services/retail-security" },
              {
                name: "Healthcare Security",
                link: "/services/healthcare-security",
              },
            ].map((service, idx) => (
              <a
                key={idx}
                href={service.link}
                className="block px-4 py-2 hover:bg-red-100"
              >
                {service.name}
              </a>
            ))}
          </div>
        </div>

        <a
          href="/technology"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Technology
        </a>
        <a
          href="/location"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Location
        </a>
        <a
          href="/career"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Career
        </a>
        <a
          href="/emergencies"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Emergencies
        </a>
        <a
          href="/contact"
          className="relative text-white after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full transform transition-transform"
        >
          Contact
        </a>
      </nav>
    </div>
  );
};

export default Navbar;
